<template>
	<page-content-layout class="products" title="Lokationer">
		<button-view slot="tools" label="Opret" @click="createButtonClick" />
		<new-table-view @itemClick="itemClick" @delete="itemDelete" :columns="[
			{
				label: 'Navn',
				name: 'name'
			},
			{
				label: 'Adresse',
				name: 'address'
			},
			{
				label: 'Postnummer',
				name: 'zip'
			},
			{
				label: 'By',
				name: 'city'
			},
			{
				label: 'Land',
				name: 'country'
			},
			{
				label: '',
				name: 'delete',
				align: 'right',
				template: {
					name: 'button',
					label: 'Slet'
				}
			}
		]" :items="items" />
	</page-content-layout>
</template>

<script>
	import Location from '../windows/LocationWindow'
	import NewTableView from '../views/NewTableView'

    export default {
		components: {
			newTableView: NewTableView
		},
		methods: {
			createButtonClick: function () {
				var contacts = this;

				

				this.$store.state.windowStack.push(Location, {
					onChange: function (ent) {
						
						

						contacts.update();
					}
				});
			},
			itemClick: function (item) {
				

				var contacts = this;

				this.$store.state.windowStack.push(Location, {id: item.id, form: true, onChange: function () {
					contacts.update();
				}});
			},
			itemDelete(item) {
				if (!confirm('Sikker?')) return;

				var view = this;

				this.axios
					.delete('/warehouse/locations/' + item.id + '/')
					.then(function (r) {
						

						if (r.status >= 200 && r.status < 300) {
							view.update();
						}

						
					}, function (err) {
						
						
						var r = err.response;

						if (r.status == 422) {
							alert(r.data);
						} else {
							alert('Server Error');
						}
					});	
			},
			itemAction: function (name, id) {
				if (name == 'delete') {
					if (!confirm('Sure?')) return;

					

					var contacts = this;

					this.axios
						.delete('/warehouse/locations/' + id + '/')
						.then(function () {
							contacts.update();
						}, function () {
							alert('Could not delete the item');
						});
				}
			},
			update() {
				var contacts = this;

				this.axios
					.get('/warehouse/locations/')
					.then(function (r) {
						contacts.items = r.data._items;
					});
			}
		},
		data: function () {
			return {
				items: [],
				actions: [{name: 'delete', label: 'Delete'}]
			};
		},
		mounted: function () {
			this.axios.put('/activity/locations/');
			this.update();


			/*this.axios
				.all([
					this.axios.get('/contacts/'),
					this.axios.get('/contacts/columns/')
				]).then(function (results) {
					
				});*/
		}
    }
</script>

<style lang="scss" scoped>
	.new-table-view {
		width: 100%;
		height: 100%;
	}
</style>